"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.v2EndpointCustom = void 0;
const axios_1 = __importDefault(require("axios"));
const utilities_1 = __importDefault(require("jsAssets/utilities"));
// v2EndpointCustom will apply for all request of review setting screen
let numberOfAjaxCallPending = 0;
const v2EndpointCustom = axios_1.default.create();
exports.v2EndpointCustom = v2EndpointCustom;
v2EndpointCustom.interceptors.request.use((config) => {
    numberOfAjaxCallPending += 1;
    utilities_1.default.blockPage();
    return config;
});
v2EndpointCustom.interceptors.response.use((response) => {
    numberOfAjaxCallPending -= 1;
    if (numberOfAjaxCallPending === 0) {
        utilities_1.default.unblockPage();
    }
    return response;
}, (error) => {
    utilities_1.default.unblockPage();
    utilities_1.default.notification.danger(error);
    return Promise.reject(error);
});
